import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";

const getInterToken = () => {
  const token = sessionStorage.interToken;
  if (token) return token;
  throw new Error("No existe ningún token cargado de Inter");
};

export const getEmisionByID = async (emisionId) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    `/v1/emision/id/${emisionId}`,
    config
  );

  return serverResponse.data;
};

export const postLeadMascotaInter = async (request) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
      "inter-token": getInterToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    `/v1/mascota/lead`,
    request,
    config
  );

  return serverResponse.data;
};

export const updatePolizaManual = async (form) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    "/v1/emision/manual/actualizar",
    form,
    config
  );

  return serverResponse;
};

export const getFormatEstadoId = (estadoName) => {
  const estadoslist = [
    { id: 1, name: "Aguascalientes" },
    { id: 2, name: "Baja California" },
    { id: 3, name: "Baja California Sur" },
    { id: 4, name: "Campeche" },
    { id: 5, name: "Coahuila de Zaragoza" },
    { id: 6, name: "Colima" },
    { id: 7, name: "Chiapas" },
    { id: 8, name: "Chihuahua" },
    { id: 9, name: "Ciudad de México" },
    { id: 10, name: "Durango" },
    { id: 11, name: "Guanajuato" },
    { id: 12, name: "Guerrero" },
    { id: 13, name: "Hidalgo" },
    { id: 14, name: "Jalisco" },
    { id: 15, name: "Estado de México" },
    { id: 16, name: "Michoacán de Ocampo" },
    { id: 17, name: "Morelos" },
    { id: 18, name: "Nayarit" },
    { id: 19, name: "Nuevo León" },
    { id: 20, name: "Oaxaca" },
    { id: 21, name: "Puebla" },
    { id: 22, name: "Querétaro" },
    { id: 23, name: "Quintana Roo" },
    { id: 24, name: "San Luis Potosí" },
    { id: 25, name: "Sinaloa" },
    { id: 26, name: "Sonora" },
    { id: 27, name: "Tabasco" },
    { id: 28, name: "Tamaulipas" },
    { id: 29, name: "Tlaxcala" },
    { id: 30, name: "Veracruz de Ignacio de la Llave" },
    { id: 31, name: "Yucatán" },
    { id: 32, name: "Zacatecas" },
  ];

  const estado = estadoslist.find(
    (e) => e.name.toLocaleLowerCase() == estadoName.toLocaleLowerCase()
  );
  console.log(estado, estadoName.toLocaleLowerCase());

  return estado ? estado.id : 1;
};

export const getEmisionesByFiltros = async (filters, limit, page) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    params: {
      filters: filters,
      limit: limit,
      page: page,
      order: "asc",
    },
  };

  const serverResponse = await mainAxios.get(`/v1/emision/filters`, config);

  return serverResponse.data;
};

export const getEmisionesOnboard = async (filters, limit, page) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    params: {
      alianza_intermx: filters.alianza_intermx_id,
      fechas: filters.fecha_emision,
      status: filters.status,
      limit: limit,
      page: page,
      order: "desc",
    },
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();
      for (const key in params) {
        if (Array.isArray(params[key])) {
          params[key].forEach((val) => searchParams.append(key, val));
        } else if (params[key] != null) {
          searchParams.append(key, params[key]);
        }
      }
      return searchParams.toString();
    },
  };

  const response = await mainAxios.get("/v1/emision/onboarding", config);
  return response.data;
};

export const getEmisionesOnboardIds = async (filters) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    params: {
      alianza_intermx: filters.alianza_intermx_id,
      fechas: filters.fecha_emision,
      status: filters.status,
    },
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();
      for (const key in params) {
        if (Array.isArray(params[key])) {
          params[key].forEach((val) => searchParams.append(key, val));
        } else if (params[key] != null) {
          searchParams.append(key, params[key]);
        }
      }
      return searchParams.toString();
    },
  };

  const response = await mainAxios.get("/v1/emision/onboarding/ids", config);
  return response.data;
};

export const postEmisionesOnboard = async (emisionesId) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };
  const params = {
    emisiones: emisionesId,
  };

  const serverResponse = await mainAxios.post(
    `/v1/emision/list/nuvalia`,
    params,
    config
  );

  return serverResponse.data;
};

export const getEmisionesPhoneValidation = async (filters, limit, page) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    params: {
      alianza_intermx: filters.alianza_intermx_id,
      fechas: filters.fecha_emision,
      limit: limit,
      page: page,
      order: "desc",
    },
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();
      for (const key in params) {
        if (Array.isArray(params[key])) {
          params[key].forEach((val) => searchParams.append(key, val));
        } else if (params[key] != null) {
          searchParams.append(key, params[key]);
        }
      }
      return searchParams.toString();
    },
  };

  const response = await mainAxios.get("/v1/emision/phone_validation", config);
  return response.data;
};

export const getEmisionesPhoneValidationIds = async (filters) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    params: {
      alianza_intermx: filters.alianza_intermx_id,
      fechas: filters.fecha_emision,
    },
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();
      for (const key in params) {
        if (Array.isArray(params[key])) {
          params[key].forEach((val) => searchParams.append(key, val));
        } else if (params[key] != null) {
          searchParams.append(key, params[key]);
        }
      }
      return searchParams.toString();
    },
  };

  const response = await mainAxios.get(
    "/v1/emision/phone_validation/ids",
    config
  );
  return response.data;
};

export const postValidatePhone = async (emisionesId) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };
  const params = {
    emisiones: emisionesId,
  };

  const serverResponse = await mainAxios.post(
    `/v1/emision/validate/phones`,
    params,
    config
  );

  return serverResponse.data;
};

export const postCargarArchivoAlianza = async (emisiones) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken()
    },
  };
  const body = {
    emisiones
  }

  const response = await mainAxios.post(
    "/v1/emision/list/manual/alianza",
    body,
    config
  );
  return response.data;
};

export const getReglasLayout = async (alianza_intermx_id, producto_id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };
  const params = {
    alianza_intermx_id: alianza_intermx_id,
    producto_id: producto_id,
  };

  const response = await mainAxios.post(
    "/v1/emision/reglas_validacion",
    params,
    config
  );
  return response.data;
};
export const getSinglePhoneValidation = async (telefono) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };
  const body = {
    telefono
  }

  const response = await mainAxios.post(
    "/v1/emision/validate/single_phone",
    body,
    config
  );
  return response.data;
};

export const consultarSolicitudesAlianzas = async (body) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const res = await mainAxios.post("/v1/reportes/solicitudes-alianzas", body, config);
  return res.data;
};

export const descargarSolicitudesAlianzasCSV = async (body) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    responseType: "blob",
  };

  const res = await mainAxios.post("/v1/reportes/solicitudes-alianzas/file", body, config);
  return res.data;
};

export const obtenerReporteFamiliares = async (body) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const response = await mainAxios.post("/v1/reportes/familiares-beneficiarios", body, config);
  return response.data;
};

export const descargarReporteFamiliaresCSV = async (body) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    responseType: "blob",
  };

  const response = await mainAxios.post("/v1/reportes/familiares-beneficiarios/file", body, config);
  return response.data;
};

export const postCargarArchivoAlianzaGenericas = async (
  file,
  alianzaId,
  productoId
) => {
  const formData = new FormData();
  formData.append("file", file);

  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const response = await mainAxios.post(
    `/v1/emision/list/manual/alianza/${alianzaId}?productoId=${productoId}`,
    formData,
    config
  );

  return response.data;
};

export const postCargarArchivoAlianzaBetter = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const response = await mainAxios.post(
    "/v1/emision/list/alianza",
    formData,
    config
  );

  return response.data;
};

const getEmisionesMasivasConfig = () => ({
  headers: {
    Authorization: "Bearer " + getAgenteAccessToken(),
  },
});

export const getJobsEmisionesBetterProcesando = async () => {
  const response = await mainAxios.get(
    "/v1/emision/masivas/jobs/procesando?proceso=EMISIONES_BETTER",
    getEmisionesMasivasConfig()
  );
  return response.data;
};

export const getJobsEmisionesBetterHistorico = async () => {
  const response = await mainAxios.get(
    "/v1/emision/masivas/jobs/historico?proceso=EMISIONES_BETTER",
    getEmisionesMasivasConfig()
  );
  return response.data;
};

export const getJobEmisionesMasivas = async (jobId) => {
  const response = await mainAxios.get(
    `/v1/emision/masivas/job/${jobId}`,
    getEmisionesMasivasConfig()
  );
  return response.data;
};

export const getErroresJobEmisionesMasivas = async (jobId) => {
  const response = await mainAxios.get(
    `/v1/emision/masivas/jobs/${jobId}/errores`,
    getEmisionesMasivasConfig()
  );
  return response.data;
};

export const postCargarArchivoFacturacionAlianzaGenericas = async (
  file,
  alianzaId,
  productoId
) => {
  const formData = new FormData();
  formData.append("file", file);

  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const response = await mainAxios.post(
    `/v1/facturacion/list/alianza/${alianzaId}?productoId=${productoId}`,
    formData,
    config
  );

  return response.data;
};
